import axios from 'axios'
import { env } from '@/config/env'
import { attachInterceptors } from './interceptors'
import { API_REQUEST_TIMEOUT_MS } from './requestTimeout'

export const apiClient = axios.create({
  baseURL: env.VITE_API_BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
  timeout: API_REQUEST_TIMEOUT_MS,
})

attachInterceptors(apiClient)
